import axios from 'axios';

// Configuration de l'URL de l'API
// En développement, utiliser directement localhost:5000 si le proxy ne fonctionne pas
// En production, utiliser REACT_APP_API_URL si défini
const API_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'development' 
    ? 'http://localhost:5000/api' 
    : '/api');

// Configuration axios
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  // Timeout pour éviter les attentes infinies
  timeout: 10000
});

// Intercepteur pour ajouter le token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Erreur de connexion au serveur
    if (!error.response) {
      console.error('Erreur de connexion au serveur:', error.message);
      return Promise.reject({
        message: 'Impossible de se connecter au serveur. Vérifiez que le serveur est démarré.',
        isNetworkError: true
      });
    }
    
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      // Ne rediriger que si on n'est pas déjà sur la page de login
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// API Auth
export const authAPI = {
  login: (username, password) => api.post('/auth/login', { username, password }),
  getMe: () => api.get('/auth/me'),
  changePassword: (oldPassword, newPassword) =>
    api.put('/auth/password', { oldPassword, newPassword }),
  register: (userData) => api.post('/auth/register', userData)
};

// API Users
export const usersAPI = {
  getAll: () => api.get('/users'),
  getById: (id) => api.get(`/users/${id}`),
  update: (id, data) => api.put(`/users/${id}`, data),
  delete: (id) => api.delete(`/users/${id}`),
  resetPassword: (id, newPassword) => api.put(`/users/${id}/password`, { newPassword })
};

// API Apprenants
export const apprenantsAPI = {
  getAll: (params) => api.get('/apprenants', { params }),
  getById: (id) => api.get(`/apprenants/${id}`),
  create: (data) => api.post('/apprenants', data),
  update: (id, data) => api.put(`/apprenants/${id}`, data),
  delete: (id) => api.delete(`/apprenants/${id}`),
  addChangementEntreprise: (id, data) =>
    api.post(`/apprenants/${id}/changement-entreprise`, data),
  import: (formData) => api.post('/apprenants/import', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
};

// API Suivis
export const suivisAPI = {
  getAll: (params) => api.get('/suivis', { params }),
  getById: (id) => api.get(`/suivis/${id}`),
  create: (data) => api.post('/suivis', data),
  update: (id, data) => api.put(`/suivis/${id}`, data),
  delete: (id) => api.delete(`/suivis/${id}`),
  // Multi-niveaux
  createMultiNiveaux: (data) => api.post('/suivis/multiniveaux', data),
  getMultiNiveaux: (apprenantId) => api.get(`/suivis/apprenant/${apprenantId}/multiniveaux`)
};

// API Config
export const configAPI = {
  get: () => api.get('/config'),
  update: (data) => api.put('/config', data),
  addItem: (type, value, category) =>
    api.post('/config/add-item', { type, value, category }),
  removeItem: (type, value, category) =>
    api.delete('/config/remove-item', { params: { type, value, category } })
};

// API Stats
export const statsAPI = {
  get: (params) => api.get('/stats', { params }),
  getSuivi: () => api.get('/stats/suivi')
};

// API Alertes
export const alertesAPI = {
  getAll: () => api.get('/alertes')
};

export default api;

